
import { defineComponent } from 'vue';
import { useField } from 'vee-validate';
import AppFormItem from '@/components/UI/AppFormItem.vue';

export default defineComponent({
  inheritAttrs: false,
  components: { AppFormItem },
  props: {
    name: { type: String, required: true },
    type: { type: String, required: true },
    format: { type: String, required: true },
    label: { type: String, required: true },
    prefix: { type: String, required: false },
    controlClass: { type: String, default: '' },
  },
  setup(props) {
    const { value, errorMessage } = useField(props.name);
    return { value, errorMessage };
  },
});
